module.exports = __webpack_public_path__ + "img/porsche_sw.727884f8.png";